// eslint-disable-next-line
import util from 'util';

import React from 'react';
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import * as Stripe from '@stripe/react-stripe-js';
import HelpIcon from '@material-ui/icons/Help';
import { IconButton, Typography, TextField } from '@material-ui/core';
import * as DataFormats from './DataFormats';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EmailValidator from "email-validator";


const styles = theme => ({
  underlineBox: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.54)',
    paddingBottom: 4,
  },
    
});


/*
 * Secure form for entering card data.
 *
 * Documentation: https://stripe.com/docs/stripe-js/react
 */
class PaymentCardForm extends React.Component {
  constructor(props) {
    super(props);

    if (this.props.paymentProcessorId ==="STRIPE_US") {
      this.state = { ...this.initialStateUS };
    } else if (this.props.paymentProcessorId === "STRIPE_CA") {
      this.state = { ... this.initialStateCA}
    } else {
      this.state = { ...this.initialStateUS };
    }

    this.state.paymentProcessorId = this.props.paymentProcessorId;

    this.cardOptions = {
      iconStyle: 'solid',
      hidePostalCode : false,
      style : {
        base : {
          fontFamily: this.props.theme.typography.fontFamily,
          fontSize: '16px',
        },
      }
    };
  }
  initialStateUS = {
    saveCard : true,
    autoPayStatus: this.props.selectedAccount.hasAchAutoPayEnabled !== "Y",
    holderName : '',
    address1: '',
    address2: '',
    city: '',
    state : '',
    country : 'US',
    cardValid : false,
    formValid : false,
    paymentProcessorId : "STRIPE_US",
    autoPayEmail: "",
    autoPayEmailError: false,
  }

  initialStateCA = {
    saveCard : true,
    autoPayStatus: this.props.selectedAccount.hasAchAutoPayEnabled !== "Y",
    holderName : '',
    address1: '',
    address2: '',
    city: '',
    state : '',
    country : 'CA',
    cardValid : false,
    formValid : false,
    paymentProcessorId : "STRIPE_CA",
    autoPayEmail: "",
    autoPayEmailError: false,
  }
  componentDidUpdate() {
    this.checkValid();
  }

  /* This is called whenever they change the credit card, expiration,
     CSV, or zip.  If the complete flag is true when it's usable */
  cardChanged = (event) => {
    if (event.complete && !this.state.cardValid) {
      this.setState({cardValid : true});
    }
    if (!event.complete && this.state.cardValid) {
      this.setState({cardValid : false});
    }

  }

  /* All other information fields */
  fieldChanged = (field, value) => {
    let change = {};
    if (field === "country" && value && value.length > 2) {
      return;
    }

    if (field === "state" && value && value.length > 2) {
      return;
    }

    change[field] = value;
    this.setState(change);
  }

  clearForm = () => {
    if (this.props.paymentProcessorId ==="STRIPE_US") {
      this.setState(this.initialStateUS);
      this.state = { ...this.initialStateUS };
    } else if (this.props.paymentProcessorId === "STRIPE_CA") {
      this.setState(this.initialStateCA);
    } else {
      this.setState(this.initialStateUS);
    }

    const cardElement = this.props.elements.getElement(Stripe.CardElement);
    cardElement.clear();
  }

  getPaymentMethod = async () => {
    const cardElement = await this.props.elements.getElement(Stripe.CardElement);
    const {error, paymentMethod} = await this.props.stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details : {
        name : this.state.holderName,
        address : {
          line1 : this.state.address1,
          line2 : this.state.address2,
          city : this.state.city,
          state : this.state.state,
          country : this.state.country,
        },
      },
    });
    
    if (error) {
      return({error});
    } else {
      return(
          {paymentMethod: paymentMethod, saveCard: this.state.saveCard, autoPayStatus: this.state.autoPayStatus, autoPayEmail: this.state.autoPayEmail, clearForm : this.clearForm}
      );
    }
  }
  
  /* Check if the form is valid */
  checkValid = () => {
    let valid = true;
    if (!this.state.cardValid) {
      valid = false;
    }
    if (this.state.holderName.length === 0) {
      valid = false;
    }
    if (this.state.address1.length === 0) {
      valid = false;
    }
    if (this.state.city.length === 0) {
      valid = false;
    }
    if (this.state.country.length === 0) {
      valid = false;
    }
    if (this.state.state.length === 0) {
      valid = false;
    } else {
      if (valid === true && (this.state.country === 'US' || this.state.country === 'CA')) {
        if (this.state.state.length !== 2) {
          valid = false;
        }
      }
    }
    if (valid === this.state.formValid) {
      return;
    }

    this.setState({formValid : valid});
    if (valid) {
      if (typeof(this.props.onValid) === 'function') {
        this.props.onValid(this.getPaymentMethod);
      }
    } else {
      if (typeof(this.props.onInvalid) === 'function') {
        this.props.onInvalid();
      }
    }
  }
  
  checkEmails = (email) => {
    if (!email) {
        return true;
    }

    let temp = email;
    let badEmail = false;
    temp = temp.replace(',', ';');

    let emails = temp.split(';');
    emails.forEach(email => {
      if (!EmailValidator.validate(email.trim())) {
        badEmail = true;
      }
    });

    return !badEmail;
  }

  render() {
    // eslint-disable-next-line
    const {classes, theme} = this.props;

    let emailList = [];
    let chkId = 0;
    if (typeof this.props.selectedAccount.billEmailTxt === 'string' || this.props.selectedAccount.billEmailTxt instanceof String) {
      chkId++;
      emailList.push({"id": chkId, "name": this.props.selectedAccount.billEmailTxt})
    }
    if (typeof this.props.selectedAccount.autoPayReceiptEmails === 'string' || this.props.selectedAccount.autoPayReceiptEmails instanceof String) {
      chkId++;
      emailList.push({"id": chkId, "name": this.props.selectedAccount.autoPayReceiptEmails})
    }
    if (typeof this.props.webUser.email === 'string' || this.props.webUser.email instanceof String) {
      chkId++;
      emailList.push({"id": chkId, "name": this.props.webUser.email})
    }
    //Remove duplicates
    emailList = [...new Set(emailList)];


    return (
      <MuiCore.Grid container spacing={1}>
        <MuiCore.Grid item xs={12} className={classes.cardLine}>
          <div className={classes.underlineBox}>
            <MuiCore.InputLabel shrink={true} style={{paddingBottom: 6}}>Card</MuiCore.InputLabel>
            <Stripe.CardElement onChange={this.cardChanged} options={this.cardOptions}/>
          </div>
        </MuiCore.Grid>
        
        <MuiCore.Grid item xs={12}>
          <MuiCore.TextField name='holderName'
                             fullWidth
                             error={this.state.holderName.length === 0}
                             value={this.state.holderName}
                             onChange={(event) => this.fieldChanged('holderName', event.target.value)}
                             label='Holder Name'/>
        </MuiCore.Grid>
        
        <MuiCore.Grid item xs={12}>
          <MuiCore.TextField name='address1'
                             error={this.state.address1.length === 0}
                             value={this.state.address1}
                             onChange={(event) => this.fieldChanged('address1', event.target.value)}          
                             fullWidth label='Address Line 1'/>
        </MuiCore.Grid>
        
        <MuiCore.Grid item xs={12}>
          <MuiCore.TextField name='address2'
                             value={this.state.address2}
                             onChange={(event) => this.fieldChanged('address2', event.target.value)}                    
                             fullWidth label='Address Line 2'/>
        </MuiCore.Grid>
        
        <MuiCore.Grid item xs={12} sm={4}>
          <MuiCore.TextField name='city'
                             error={this.state.city.length === 0}
                             value={this.state.city}
                             onChange={(event) => this.fieldChanged('city', event.target.value)}                    
                             fullWidth label='City'/>
        </MuiCore.Grid>

        {/*Note - the ZIPCODE/POSTAL CODE Field is not included and NEVER WAS. We (Sam, Kordel, Melissa) believe it's not used by Stripe */}

        <MuiCore.Grid item xs={12} sm={4}>
          <MuiCore.TextField name='state'
                             error={this.state.state.length === 0}
                             value={this.state.state}
                             onChange={(event) => this.fieldChanged('state', event.target.value)}                    
                             fullWidth label='State/Province'/>
        </MuiCore.Grid>
        
        <MuiCore.Grid item xs={12} sm={4}>
          <MuiCore.TextField name='country'
                             error={this.state.country.length === 0 && this.state.country.length !== 2}
                             value={this.state.country}
                             onChange={(event) => this.fieldChanged('country', event.target.value)}                    
                             fullWidth label='Country Code'/>
        </MuiCore.Grid>

        <MuiCore.Grid item xs={12}>
          <MuiCore.FormControlLabel control={<MuiCore.Checkbox
                                               onChange={(event) => this.setState({saveCard: event.target.checked})}
                                               checked={this.state.saveCard} />} label="Save Card" />
        </MuiCore.Grid>

        {this.state.saveCard &&
          <MuiCore.Grid item xs={12}>
            <MuiCore.FormControlLabel control={<MuiCore.Checkbox
                onChange={(event) => this.setState({autoPayStatus: event.target.checked})}
                checked={this.state.autoPayStatus} />} label={
              <div>
                <Typography variant='body1'>
                  I authorize <b>{this.props.selectedAccount.statementGroupName}</b> to electronically debit my account as payments become due.
                </Typography>
                <Typography variant='body2'>
                  (You may disable electronic payments at any time from this portal or by calling <b style={{whiteSpace: 'nowrap'}}>
                  {DataFormats.phoneNumber(this.props.selectedAccount.statementGroupBillingPhone)}</b>.)
                </Typography>
              </div>
            }
            />
            {this.state.autoPayStatus &&
              <MuiCore.FormControl fullWidth>
                <Autocomplete freeSolo options={emailList}
                              onChange={(event, newValue) => {
                                if (typeof newValue === 'object' && newValue !== null) {
                                  this.setState({autoPayEmail: newValue.name})
                                } else if (newValue !== null) {
                                  this.setState({autoPayEmail: newValue})
                                }
                              }}
                              onInputChange={(event, newValue) => {
                                if (typeof newValue === 'object' && newValue !== null) {
                                  this.setState({autoPayEmail: newValue.name})
                                } else if (newValue !== null) {
                                  this.setState({autoPayEmail: newValue})
                                }
                              }}
                              inputValue={this.state.autoPayEmail}
                              getOptionLabel={(option) => option.name}
                              renderInput={(params) => (<TextField
                                {...params}
                                label="Auto Pay Receipt Emails"
                                margin="normal"
                                variant="outlined"
                                error={!this.checkEmails(this.state.autoPayEmail)}
                                inputProps={{ ...params.inputProps, maxLength: 500}}
                                InputProps={{...params.InputProps, type: 'search'}}
                                InputLabelProps={{ style: {backgroundColor: "white"}}}
                              />)}
                />
              </MuiCore.FormControl>
            }
          </MuiCore.Grid>
        }
      </MuiCore.Grid>

    );
  }
}

export default withStyles(styles, { withTheme: true })(PaymentCardForm);

